import { gql } from '@apollo/client';

export const GET_CURRENT_USER_PACKAGES = gql`
  query CurrentUserPackages {
    currentUserPackages {
      nodes {
        discount
        name
        paidAdsCount
        period
        price
        walletAmount
        expiresAt
      }
    }
  }
`;

export const GET_PACKAGES_LIST = gql`
  query PackagesList($segment: ShopSegmentEnum) {
    packages(segment: $segment) {
      segment
      packages {
        name
        discount
        paidAdsCount
        walletAmount
        promotions
        periods {
          value
          originalPrice
          promoPrice
          price
          isPromoPriceActive
          promoPriceDiscount
          showPromoPriceLabel
          isPromotionActive
          promotionDiscount
          promotionDiscountAmount
          showPromotionLabel
        }
      }
    }
  }
`;

export const GET_INVOICE_PROMOTION = gql`
  query InvoicePromotion {
    invoicePromotion {
      title
      shortDescription
      description
      primaryColor
      secondaryColor
      textColor
      iconUrl
      bannerUrl
    }
  }
`;

export const GET_INVOICE_PROMOTION_PACKAGES = gql`
  query InvoicePromotionPackages($segment: ShopSegmentEnum!) {
    packages(segment: $segment) {
      packages {
        name
        periods {
          value
          originalPrice
          price
          showPromotionLabel
        }
      }
    }
  }
`;

export const GET_INVOICE_PRECREATE_ANALYZE = gql`
  query InvoicePrecreateAnalyze(
    $period: InvoicePeriodEnum!
    $startsAt: InvoiceStartsAtEnum!
    $tariffPlanTitle: String!
  ) {
    invoicePrecreateAnalyze(
      period: $period
      startsAt: $startsAt
      tariffPlanTitle: $tariffPlanTitle
    ) {
      hasWarning
      warning {
        title
        text
      }
    }
  }
`;
